module.exports = __webpack_public_path__ + "img/intro1.a7910281.png";